import { ArrowDropDown, Person, QueryBuilder } from "@material-ui/icons";
import { GiTicket } from "react-icons/gi";
import { BiPlusMedical, BiCalendar } from "react-icons/bi";
import { FaRegMoneyBillAlt } from "react-icons/fa";

import "./project.css";
import { Link } from "react-router-dom";

function Project(props) {
  return (
    <div className="project">
      <div className="projectHeader">
        <div className="projectHeaderRight">
          <Link to={`/project/${props.id}`} className="projectHeaderRightTitle">
            {props.offer && (
              <>
                <bdi className="label">مُغلق</bdi>{" "}
              </>
            )}

            {props.title}
          </Link>
          <div className="projectHeaderRightIcons">
            <div className="projectHeaderItem">
              <Person className="projectHeaderRightIcon" />
              <span className="projectHeaderRightText">{props.username}</span>
            </div>
            <div className="projectHeaderItem">
              <QueryBuilder className="projectHeaderRightIcon" />
              <span className="projectHeaderRightText"> {props.time}</span>
            </div>
            {!props.offer && (
              <div className="projectHeaderItem">
                <GiTicket className="projectHeaderRightIcon" />
                <span className="projectHeaderRightText">
                  {props.offersNumber}
                </span>
              </div>
            )}
            {props.offer && (
              <>
                <div className="projectHeaderItem">
                  <FaRegMoneyBillAlt className="projectHeaderRightIcon" />
                  <span className="projectHeaderRightText">{props.price}</span>
                </div>
                <div className="projectHeaderItem">
                  <BiCalendar className="projectHeaderRightIcon" />
                  <span className="projectHeaderRightText">
                    {props.duration}
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
        {props.button && (
          <div className="projectHeaderLeft">
            <button className="projectHeaderLeftButton">
              <span className="projectHeaderLeftButtonRight">
                <BiPlusMedical style={{ marginLeft: "5px" }} />
                <span>أضف عرضك</span>
              </span>
              <ArrowDropDown
                className="projectHeaderLeftButtonDropDown"
                style={{ borderRight: "0.1px solid #1c6ca1" }}
              />
            </button>
          </div>
        )}
      </div>
      <div className="projectDesc">{props.description}</div>
    </div>
  );
}

export default Project;
